import * as z from "zod";

export const deleteTotes = {
  name: "deleteTotes" as const,
  input: z.object({ toteIds: z.array(z.string()) }),
  output: z.object({
    success: z.boolean(),
    deletedToteIds: z.array(z.string()),
    blocked: z.array(
      z.object({
        toteId: z.string(),
        name: z.string(),
        reason: z.enum(["in_pick_session", "has_inventory"]),
        quantity: z.number().optional(),
      }),
    ),
  }),
};

export type DeleteTotesInput = z.infer<typeof deleteTotes.input>;
export type DeleteTotesOutput = z.infer<typeof deleteTotes.output>;
